import { connect } from 'react-redux';
import NavigationTabs from 'src/components/NavigationTabs/NavigationTabs';
import { getScreenCustom, getScreenData, setScreenData, showDrawer, Store } from 'cw-ui-core';
import IMPORTED_USERS from 'src/features/users/components/ImportedUsers/Constants';
import { hasFeature, Features } from 'src/util/featureToggles';
import {
    loadImportedUsersCount,
    getContactListForMappedToCrm,
    countContactsMappedToCrm,
} from 'src/services/ImportedUsersService';
import _ from 'lodash';
import { toMap, checkUserForFullAuthorization } from 'src/util/Util';
import { getOriginPartnerId } from 'src/services/ApiService';

const mapStateToProps = state => {
    const hideTabs = getScreenCustom(state.screen, ['hideTabs']);
    const contactsMappedToCrmCount = getScreenData(state.screen, ['contactsMappedToCrmCount']);
    const partnerOptInStatus = toMap(getScreenData(state.screen, ['partnerOptInStatus']));
    const hasNewIdentityRolesFeature = hasFeature(Features.NEW_IDENTITY_ROLES_FEATURE);
    const hasNewUsersFeature = hasFeature(Features.NEW_USERS_FEATURE);
    const hasNewProductsFeature = hasFeature(Features.NEW_PRODUCTS_FEATURE);
    const originPartnerId = getOriginPartnerId();
    const shouldShowSubscribers = state.subscribers.subscribers.rows.length > 0 && checkUserForFullAuthorization();

    return {
        hideTabs,
        contactsMappedToCrmCount,
        hasNewIdentityRolesFeature,
        hasNewUsersFeature,
        hasNewProductsFeature,
        showApplicationRoleManagementTab: !_.isEmpty(partnerOptInStatus),
        originPartnerId,
        shouldShowSubscribers,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onDidMount: () => {
            Store().runSaga(loadImportedUsersCount);
            Store().runSaga(countContactsMappedToCrm);
        },
        onWillUnmount: () => {
            dispatch(setScreenData(['features'], undefined, 'SkyLab'));
        },
        onContactMatchButtonClick: () => {
            dispatch(showDrawer(IMPORTED_USERS));
            Store().runSaga(getContactListForMappedToCrm);
        },
    };
};

const NavigationTabsContainer = connect(mapStateToProps, mapDispatchToProps)(NavigationTabs);

export default NavigationTabsContainer;
